import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_buttonView/_layout/retain/_app')({});
